<template>
  <el-dialog :visible.sync="visible" width="400px" :show-close="activated" :close-on-click-modal="false"
    custom-class="compliance-reward-dialog">
    <div class="reward-header">
      <div class="reward-icon-circle">
        <i v-if="!activated" class="bx bx-gift text-3xl text-white opacity-70"></i>
        <i v-else class="bx bx-party text-3xl text-white opacity-70"></i>
      </div>
      <div v-if="!activated">
        <h1 class="text-2xl font-bold text-white mt-4">🎉 ¡Felicidades! <br />Desbloqueaste tu recompensa</h1>
        <p class="text-white opacity-80 text-sm mt-2">Terminaste tu configuración inicial y desbloqueaste:</p>
      </div>
      <div v-else>
        <h1 class="text-2xl font-bold text-white mt-4">✨ ¡Oferta activada con éxito!</h1>
      </div>
    </div>

    <div class="reward-body">
      <div v-if="!activated">
        <div class="premium-card">
          <span class="star">✦</span>
          <div class="text-center">
            <p class="text-purple-700 font-bold text-lg">✦ PRIMER MES PREMIUM</p>
            <p class="text-gray-600 text-sm mt-1">al precio del plan <span
                class="text-purple-700 font-bold">BÁSICO</span></p>
          </div>
          <span class="star">✦</span>
        </div>
        <p class="text-gray-500 text-sm text-center mt-4">Accede a todas las funciones PREMIUM desde hoy.</p>
        <sa-button class="text-center mt-6" @click="activate">
          Activar oferta PREMIUM →
        </sa-button>
        <div class="text-center mt-3">
          <el-button type="text" class="text-gray-500" @click="close">Ver después</el-button>
        </div>
        <p class="text-center text-xs text-gray-400 mt-2">
          <i class="bx bx-time-five mr-1"></i>Beneficio válido por tiempo limitado
        </p>
      </div>

      <div v-else>
        <div class="flex items-center gap-2 mb-4">
          <i class="bx bx-check-circle text-purple-700 text-2xl"></i>
          <p class="font-bold text-gray-800">Tu descuento ya quedó reservado para ti.</p>
        </div>
        <p class="text-gray-600 text-sm text-center mb-4">
          Obtendrás tu <span class="text-purple-700 font-bold">PRIMER MES PREMIUM</span> al precio del plan
          <span class="text-purple-700 font-bold">BÁSICO</span> cuando termine tu periodo de prueba gratuita.
        </p>
        <div class="info-card">
          <div class="flex items-center gap-2 mb-3">
            <i class="bx bx-check-circle text-purple-700"></i>
            <p class="text-purple-700 font-semibold text-sm">No perderás ningún día de tu prueba actual.</p>
          </div>
          <div class="flex items-start gap-2">
            <i class="bx bx-calendar text-purple-700 mt-0.5"></i>
            <div>
              <p class="text-gray-800 text-sm font-semibold">Tu prueba finaliza el: <span class="font-bold">{{
                membershipEndDate }}</span></p>
              <p class="text-gray-500 text-xs mt-1">Tu descuento se aplicará automáticamente a partir de esa fecha.
                <strong>No necesitas hacer nada más.</strong>
              </p>
            </div>
          </div>
        </div>
        <sa-button class="text-center mt-6" @click="close">
          Continuar usando Samii
        </sa-button>
        <div class="text-center mt-3">
          <el-button type="text" class="text-purple-700" @click="goToMembership">
            Ver detalles de mi suscripción →
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'AccountComplianceReward',
  props: {
    show: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      activated: false,
    };
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(v) {
        if (!v) this.close();
      }
    },
    membershipEndDate() {
      const date = this.$store.state.account.membershipEndDate;
      if (!date) return '';
      return this.$moment(date).format('DD/MM/YYYY');
    }
  },
  methods: {
    activate() {
      this.activated = true;
    },
    close() {
      this.activated = false;
      this.$emit('close');
    },
    goToMembership() {
      this.close();
      this.$router.push({ name: 'administration.membership' });
    }
  }
};
</script>

<style>
.compliance-reward-dialog {
  border-radius: 16px;
  overflow: hidden;
  padding: 0 !important;
}

.compliance-reward-dialog .el-dialog__header {
  display: none;
}

.compliance-reward-dialog .el-dialog__body {
  padding: 0;
}

.reward-header {
  background: linear-gradient(160deg, #7c3aed, #6d28d9);
  padding: 32px 24px 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.reward-icon-circle {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}

.reward-body {
  padding: 24px;
  background: white;
}

.premium-card {
  background: #f5f3ff;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
}

.star {
  color: #7c3aed;
  font-size: 18px;
}

.info-card {
  background: #f5f3ff;
  border-radius: 12px;
  padding: 16px;
}
</style>